<mat-card class="category-card" *ngIf="data">
  <img class="category-card__icon" src="{{ data.icon }}" alt="Icono actividad" />
  <span class="category-card__title">{{ data.title }}</span>
</mat-card>
